import appConstants from '@/config/constants';
import appConfig from '@/config/config';

const HIP_MITIGATOR = 30;
const WRISTS_Y_MITIGATOR = 50;

const getRelevantKeypoints = (keypoints, bodyParts) => {
  const bodyPartsObj = {};
  for (const keypoint of keypoints) {
    if (bodyParts.includes(keypoint.part)) {
      bodyPartsObj[keypoint.part] = keypoint;
    }
  }
  return bodyPartsObj;
};

// isAccurate will return true only if every keypoint is accurate enought
const isAccurate = (keypoinstArr, specificVowelAccuracy) =>
  // eslint-disable-next-line
  keypoinstArr.every(keypoint => keypoint.score >= (specificVowelAccuracy || appConfig.accuracy )); // if accuracy not given, use default 

const isBetweenHips = (wristPos, rightHipPos, leftHipPos) =>
  wristPos.x >= rightHipPos.x - HIP_MITIGATOR &&
  wristPos.x <= leftHipPos.x + HIP_MITIGATOR;

const detectVowelI = (wrist, { leftHip, rightHip }) => {
  const isAccurateRes = isAccurate([wrist, leftHip, rightHip], 0.2);
  const isBelowHips =
    wrist.position.y >=
    (leftHip.position.y + rightHip.position.y) / 2; /* hipHeight */
  if (
    isAccurateRes &&
    isBelowHips &&
    isBetweenHips(wrist.position, rightHip.position, leftHip.position)
  ) {
    return true;
  }
};

const detectVowelA = bodyPartsObj => {
  const bodyPartsArr = Object.values(bodyPartsObj);

  const isWristsXBigger =
    bodyPartsObj.leftWrist.position.x > bodyPartsObj.leftElbow.position.x &&
    bodyPartsObj.rightWrist.position.x < bodyPartsObj.rightElbow.position.x;

  const min = Math.min(...bodyPartsArr.map(bodyPart => bodyPart.position.y));
  const max = Math.max(...bodyPartsArr.map(bodyPart => bodyPart.position.y));
  if (isAccurate(bodyPartsArr) && max - min < 100 && isWristsXBigger) {
    return appConstants.vowels.VOWEL_A;
  }
};

const detectionProcessVowelA = keypoints => {
  const bodyPartsObj = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_A
  );
  return detectVowelA(bodyPartsObj); // return String, name of vowel
};

const detectionProcessVowelI = keypoints => {
  const otherVowels =
    detectionProcessVowelA(keypoints) ||
    detectionProcessVowelShva(keypoints) ||
    detectionProcessVowelE(keypoints) ||
    detectionProcessVowelO(keypoints);
  // fetching the relevant keypoints (of body parts) for this vowel and retrieving it as an objecj
  const { rightHip, leftHip, rightWrist, leftWrist } = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_I
  );
  // console.log({ rightHip }, { leftHip }, { rightWrist }, { leftWrist });
  // trying to recognize a vowel for both hands
  const isLeftWrist = detectVowelI(leftWrist, { leftHip, rightHip });
  const isRightWrist = detectVowelI(rightWrist, { leftHip, rightHip });
  if ((isLeftWrist || isRightWrist) && !otherVowels) {
    return appConstants.vowels.VOWEL_I;
  }
};

const isAboveShoulder = (shoulderY, elbowY, wristY) =>
  elbowY < shoulderY && wristY < elbowY;

const detectVowelOLeft = (leftShoulder, leftElbow, leftWrist) => {
  // if (
  //   !isAccurate(
  //     [leftShoulder, leftElbow, leftWrist],
  //     appConfig.vowelsAccuracy.VOWEL_O
  //   )
  // ) {
  //   // if not accurate, stop process.
  //   return false;
  // }

  const isOutsideBodyLeftX =
    leftShoulder.position.x < leftElbow.position.x &&
    leftElbow.position.x <= leftWrist.position.x;

  // eslint-disable-next-line
  return recognitionVowelO(leftShoulder, leftElbow, leftWrist, isOutsideBodyLeftX);
};

const detectVowelORight = (rightShoulder, rightElbow, rightWrist) => {
  // if (
  //   !isAccurate(
  //     [rightShoulder, rightElbow, rightWrist],
  //     appConfig.vowelsAccuracy.VOWEL_O
  //   )
  // ) {
  //   // if not accurate, stop process.
  //   return false;
  // }
  const isOutsideBodyRightX =
    rightShoulder.position.x > rightElbow.position.x &&
    rightElbow.position.x >= rightWrist.position.x;

  // eslint-disable-next-line
  return recognitionVowelO(rightShoulder, rightElbow, rightWrist, isOutsideBodyRightX);
};

// eslint-disable-next-line
const recognitionVowelO = (shoulder, elbow, wrist, isOutsideBody /* Boolean */) => {
  if (
    isAboveShoulder(shoulder.position.y, elbow.position.y, wrist.position.y) &&
    isOutsideBody
  ) {
    return true;
  }
};

const detectionProcessVowelO = keypoints => {
  const bodyPartsObj = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_O
  );
  // const isRightSideAccurate = isAccurate([
  //   bodyPartsObj.rightShoulder,
  //   bodyPartsObj.rightElbow,
  //   bodyPartsObj.rightWrist
  // ]);

  // trying to recognize a vowel for both hands
  let isRightSide;
  // if (isRightSideAccurate) {
  isRightSide = detectVowelORight(
    bodyPartsObj.rightShoulder,
    bodyPartsObj.rightElbow,
    bodyPartsObj.rightWrist
  );
  // }

  // const isLeftSideAccurate = isAccurate(
  //   [bodyPartsObj.leftShoulder, bodyPartsObj.leftElbow, bodyPartsObj.leftWrist],
  //   appConfig.vowelsAccuracy.VOWEL_O
  // );
  let isLeftSide;
  // if (isLeftSideAccurate) {
  isLeftSide = detectVowelOLeft(
    bodyPartsObj.leftShoulder,
    bodyPartsObj.leftElbow,
    bodyPartsObj.leftWrist
  );
  // }

  if (
    // (isLeftSide && !isRightSideAccurate) ||
    // (isRightSide && !isLeftSideAccurate)
    isLeftSide ||
    isRightSide
  ) {
    return appConstants.vowels.VOWEL_O;
  }
};

const isBetweenShoulders = (leftShoulderPos, rightShoulderPos, wristPos) =>
  wristPos.x < leftShoulderPos.x &&
  wristPos.x > rightShoulderPos.x &&
  wristPos.y > rightShoulderPos.y && // checking the wrist is UNDER the right shoulder.
  wristPos.y > leftShoulderPos.y; // checking the wrist is UNDER the left shoulder.

// eslint-disable-next-line prettier/prettier
const isHandsInsideTorso = ({ leftShoulder, rightShoulder, rightWrist, leftWrist, rightHip, leftHip }) => {
  if (
    !isAccurate([
      leftShoulder,
      rightShoulder,
      rightWrist,
      leftWrist,
      rightHip,
      leftHip
    ])
  ) {
    return false;
  }
  // eslint-disable-next-line prettier/prettier
  const isRightWristBetweenShoulders = isBetweenShoulders(leftShoulder.position, rightShoulder.position, rightWrist.position);
  // eslint-disable-next-line prettier/prettier
  const isLeftWristBetweenShoulders = isBetweenShoulders(leftShoulder.position, rightShoulder.position, leftWrist.position);
  // eslint-disable-next-line prettier/prettier
  const isRightWristBetweenHipsRes = isBetweenHips(rightWrist.position, rightHip.position, leftHip.position);
  // eslint-disable-next-line prettier/prettier
  const isLeftWristBetweenHipsRes = isBetweenHips(rightWrist.position, rightHip.position, leftHip.position);

  const isRightWristAboveHips =
    rightWrist.position.y <=
    (leftHip.position.y + rightHip.position.y) / 2; /* hipHeight */

  const isLeftWristAboveHips =
    leftWrist.position.y <=
    (leftHip.position.y + rightHip.position.y) / 2; /* hipHeight */
  if (
    isRightWristBetweenShoulders &&
    isLeftWristBetweenShoulders &&
    isRightWristBetweenHipsRes &&
    isLeftWristBetweenHipsRes &&
    isRightWristAboveHips &&
    isLeftWristAboveHips
  ) {
    return true;
  }
};

const detectionProcessVowelShva = keypoints => {
  const bodyPartsObj = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_SHVA
  );

  const isWristsYDifferent =
    Math.abs(
      bodyPartsObj.rightWrist.position.y - bodyPartsObj.leftWrist.position.y
    ) > WRISTS_Y_MITIGATOR;
  if (isHandsInsideTorso(bodyPartsObj) && isWristsYDifferent) {
    return appConstants.vowels.VOWEL_SHVA;
  }
};

const detectionProcessVowelE = keypoints => {
  const bodyPartsObj = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_E
  );

  const isWristsYSimilar =
    Math.abs(
      bodyPartsObj.rightWrist.position.y - bodyPartsObj.leftWrist.position.y
    ) <=
    WRISTS_Y_MITIGATOR / 2; // aiming for more accuracy, so dividing mitigator by 2
  if (isHandsInsideTorso(bodyPartsObj) && isWristsYSimilar) {
    return appConstants.vowels.VOWEL_E;
  }
};

const isLeftWristLeftToHip = (
  leftShoulderPos,
  leftElbowPos,
  leftWristPos,
  leftHipPos
) =>
  leftWristPos.x > leftHipPos.x &&
  leftElbowPos.y > leftShoulderPos.y &&
  leftWristPos.y > leftElbowPos.y;

const isRightWristRightToHip = (
  rightShoulderPos,
  rightElbowPos,
  rightWristPos,
  rightHipPos
) =>
  rightWristPos.x < rightHipPos.x &&
  rightElbowPos.y > rightShoulderPos.y &&
  rightWristPos.y > rightElbowPos.y;

const detectionProcessVowelU = keypoints => {
  const bodyPartsObj = getRelevantKeypoints(
    keypoints,
    appConstants.vowelBodyParts.VOWEL_U
  );

  if (
    !isAccurate(
      Object.values(bodyPartsObj),
      appConfig.vowelsAccuracy.VOWEL_U // 0.3
    )
  ) {
    return false;
  }

  // trying to recognize a vowel for both hands
  const isRightSideTop = detectVowelORight(
    bodyPartsObj.rightShoulder,
    bodyPartsObj.rightElbow,
    bodyPartsObj.rightWrist
  );

  const isLeftSideTop = detectVowelOLeft(
    bodyPartsObj.leftShoulder,
    bodyPartsObj.leftElbow,
    bodyPartsObj.leftWrist
  );

  // vowel u movement is quite complex.
  // there are 2 ways it can be done, one for each side (left & right). one wrist has to be over the shoulder and farther out of the elbow (relative to the body)
  // the other wrist has to be below the shoulder and elbow and farther from the body.
  if (
    (isRightSideTop &&
      !isLeftSideTop &&
      isLeftWristLeftToHip(
        bodyPartsObj.leftShoulder.position,
        bodyPartsObj.leftElbow.position,
        bodyPartsObj.leftWrist.position,
        bodyPartsObj.leftHip.position
      )) ||
    (isLeftSideTop &&
      !isRightSideTop &&
      isRightWristRightToHip(
        bodyPartsObj.rightShoulder.position,
        bodyPartsObj.rightElbow.position,
        bodyPartsObj.rightWrist.position,
        bodyPartsObj.rightHip.position
      ))
  ) {
    return appConstants.vowels.VOWEL_U;
  }
};

export default {
  detectionProcessVowelI,
  detectionProcessVowelA,
  detectionProcessVowelO,
  // the main difference between shva and E is the height (y) of the wrists - in shva they it must be different, in E it must be similar
  detectionProcessVowelShva,
  detectionProcessVowelE,
  detectionProcessVowelU
};
